var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayouts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.5 17.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,4.51v0a.46.46,0,0,1-.23.4L8.35,8.85a.48.48,0,0,1-.7,0,.48.48,0,0,1,0-.7L10.77,5H.5a.5.5,0,0,1-.5-.5A.5.5,0,0,1,.5,4H10.82L7.65.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0l4,4A.51.51,0,0,1,12.5,4.51Zm0,8.71a.5.5,0,0,1-.5.5H1.68L4.85,16.9a.48.48,0,0,1,0,.7.48.48,0,0,1-.7,0l-4-4A.51.51,0,0,1,0,13.24v0a.46.46,0,0,1,.23-.4L4.15,8.9a.49.49,0,0,1,.7.7L1.73,12.72H12A.5.5,0,0,1,12.5,13.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayouts);
export default __webpack_public_path__ + "static/media/payouts.439b5b557d10b1fd00bfe78852c3a635.svg";
export { ForwardRef as ReactComponent };